import { useRowsStore } from "./rows";

export const useStore = () => ({
  rows: useRowsStore(),
});
